export const ALLOWED_NICHES = 5;
export const ERROR_GET_NICHES = "Could not fetch niches, please try again later";
export const ERROR_SAVE_NICHES = "Could not save niches, please try again";
export const EMPTY_NICHES_MESSAGE = "You must follow a niche to add content to it";
export const MAX_NICHES_MESSAGE = "Content can be added to a maximum of 5 niches";
export const NOT_AVAILABLE_MESSAGE = "Content has been previously removed from this niche";
